export default {
  updateEmail (state, value) {
    state.email = value
  },
  loadCupom (state, payload) {
    state.logo = payload.logo
    state.registerUrl = payload.registerUrl
    state.providerUrl = payload.providerUrl
  },
  toggleLoadingLogo (state, value) {
    state.loadingLogo = value
  },
  resetLogo (state) {
    state.logo = ''
  },
  toggleLoadingEmail (state, value) {
    state.loadingEmail = value
  }
}



// WEBPACK FOOTER //
// ./src/store/Checkin/mutations.js